import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';

import Login from './pages/Login'
import HomePage from './pages/HomePage'

function App() {
  	return (
    	<>
			<Routes>
				<Route path="/" element={<Login />} />
				<Route path="/homepage" element={<HomePage />} />
				<Route path="*" element={<Login />} />
			</Routes>
		</>
  );
}

export default App;
